export const getDateWithoutTimezone = (date) => {
	const tempDate = new Date(date);
	const userTimezoneOffset = tempDate.getTimezoneOffset() * 60000;
	return new Date(tempDate.getTime() + userTimezoneOffset);
};

export const formatTimeFromMilliseconds = (milliseconds) => {
	const seconds = Math.floor((milliseconds / 1000) % 60);
	const minutes = Math.floor((milliseconds / 1000 / 60) % 60);
	const hours = Math.floor((milliseconds / 1000 / 60 / 60) % 24);
	const getPadStart = (timeNumber) => timeNumber.toString().padStart(2, '0');
	const timeParts = [getPadStart(hours), getPadStart(minutes)];
	if (seconds > 0) {
		timeParts.push(getPadStart(seconds));
	}
	return timeParts.join(':');
};
